import { render, staticRenderFns } from "./logStatistics.vue?vue&type=template&id=774db65b&scoped=true"
import script from "./logStatistics.vue?vue&type=script&lang=js"
export * from "./logStatistics.vue?vue&type=script&lang=js"
import style0 from "./logStatistics.vue?vue&type=style&index=0&id=774db65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774db65b",
  null
  
)

export default component.exports